import { useEffect, useRef, useState } from 'react';
import { useGlobalState } from '../../contexts/GlobalState';
import RadioButtonComponent from '../../ui/RadioButtonComponent';
import ButtonGreen from './ButtonGreen';
import { useHome } from '../../contexts/HomeContext';
import Loader from '../../ui/Loader';
import RadioButtonComponentLandscapes from '../../ui/RadioButtonComponentLandscapes';

const SelectPrimaryPill = () => {
    const [open, setOpen] = useState(false);
    const { state: homeState, dispatch, loading, gettingGreenpillCounts, putSelectedPill } = useHome();
    const { state: landscapesState } = useGlobalState();
    const { greenPillNFTsHoldByWalletAddress, greenPillNFTsCountInLandscapes } = homeState;
    console.log(landscapesState, 'landscapesState');

    const myRef = useRef();
    const { landscapes } = landscapesState;
    useEffect(() => {
        function handleClick(e) {
            if (myRef.current && !myRef.current.contains(e.target)) {
                setOpen(false);
            }
        }
        document.addEventListener('click', handleClick, true);
        return () => document.removeEventListener('click', handleClick, true);
    }, []);

    const filteredBy = homeState?.selectedPill ? homeState?.selectedPill : 'Select Primary Pill';

    return (
        <div className="relative" ref={myRef}>
            <ButtonGreen
                onClick={() => setOpen((prev) => !prev)}
                w={'w-[12.5rem]'}
                name={
                    loading ? (
                        <div className="flex w-full flex-1 items-center justify-center">
                            <Loader w="w-6" h="h-6" fillColor="fill-[#326F58]" />
                        </div>
                    ) : homeState?.selectedPill ? (
                        filteredBy?.name
                    ) : (
                        filteredBy
                    )
                }
            />
            <div
                className={`z-[2000] w-64 ${
                    open ? 'absolute' : 'hidden'
                } bg-[#3C504B]  overflow-auto h-[40vh] main rounded-lg rounded-t-none shadow px-4 py-3`}
            >
                <div>
                    <RadioButtonComponentLandscapes
                        className={'flex-col mt-2'}
                        selectedOption={homeState?.selectedPill ? filteredBy?.name : homeState?.selectedPill}
                        onSelectOption={(option) => {
                            // const found = greenPillNFTsHoldByWalletAddress?.find(({ name }) => name === option);
                            const found = greenPillNFTsHoldByWalletAddress?.find(
                                ({ chainName, contractAddress, tokenId }) =>
                                    chainName + contractAddress + tokenId ===
                                    option?.chainName + option?.contractAddress + option?.tokenId
                            );

                            console.log(found, option, greenPillNFTsHoldByWalletAddress, 'found');
                            putSelectedPill(found);
                            setOpen(false);
                        }}
                        options={greenPillNFTsHoldByWalletAddress}
                    />
                </div>
            </div>
        </div>
    );
};

export default SelectPrimaryPill;
